export const validTabs = ["profile", "organizations", "notifications"] as const;

export type AccountTab = (typeof validTabs)[number];
